
export default function MembersHero() {
  return (
    <section 
      className="relative py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/3277b3d05458c8ed79768477f60e2500.jpg')`
      }}
    >
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl font-bold mb-6">
            Our Members & Partner Companies
          </h1>
          <p className="text-xl mb-8 leading-relaxed">
            Connect with a diverse network of successful entrepreneurs, innovative startups, 
            and established companies. Our community spans across industries and continents, 
            creating endless opportunities for collaboration and growth.
          </p>
        </div>
      </div>
    </section>
  );
}